var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfileBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    viewBox: "0 0 3527.7809 3520.38",
    id: "svg20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileBlueHead",
    x2: 1193.5035,
    y2: 2188.102,
    gradientTransform: "scale(1.0000055,0.99999454)",
    x1: 1193.5035,
    y1: 356.47198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8EBFC",
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05a6f2",
    id: "stop4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "profileBlueBody",
    x2: 216.51201,
    y2: 6316.6766,
    gradientTransform: "scale(1.6293322,0.61374837)",
    x1: 216.51201,
    y1: 4151.5069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42BCF5",
    id: "stop7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A6F2",
    id: "stop9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(-352.77,-356.47003)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#profileBlueBody)",
    d: "m 352.77,3530.32 c 0,231.1 115.43,346.53 346.54,346.53 h 2821.67 c 483.06,0 551.86,-729.2 -246.91,-1089.66 -1155.62,-521.51 -2921.3,-152.91 -2921.3,743.13 z",
    id: "path14",
    style: {
      fill: "url(#profileBlueBody)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#profileBlueHead)",
    cx: 2109.3301,
    cy: 1272.28,
    rx: 915.82001,
    ry: 915.81,
    id: "ellipse16",
    style: {
      fill: "url(#profileBlueHead)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileBlue);
export default __webpack_public_path__ + "static/media/icon-profile-blue.0deb79f92100fe350b56099388ca9a14.svg";
export { ForwardRef as ReactComponent };